<rpshared-save-bar [title]="title$ | async" [isSaving]="isSaving$ | async" [isFormInvalid]="invalidSubmission$ | async"
	(save)="save($event)"></rpshared-save-bar>

<div class="toolbar-margin"></div>

<div [formGroup]="form" fxLayout="column" fxLayoutGap="8px">
	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxLayoutGap="8px">
		<div fxFlex.gt-md="65%" fxLayout="column" fxLayoutGap="8px">
			<rpshared-mat-loading-card [isLoading]="isLoading$ | async" icon="train" title="General Information">
				<rpfsa-job-general-info formControlName="generalInfo"
					[railroad]="railroad$ | async"></rpfsa-job-general-info>
				<mat-card-actions fxLayout fxLayoutAlign="space-around center" *ngIf="jobIsOngoing; else status">
					<div fxLayout="column">
						<button mat-button color="primary"
							rpsharedConfirm="This action will immediately request a new Job Setup Form. Continue?"
							(onConfirmed)="requestNewJobSetupForm()">
							Request New Job Setup Form
						</button>
						<small *ngIf="generalInfo.jobSetupFormRefreshDate" fxFlexAlign="center">Last requested on
							<em>{{
								generalInfo.jobSetupFormRefreshDate
								| date: 'longDate':'utc'
								}}</em>
						</small>
					</div>
					<button mat-button color="warn" rpsharedConfirm="Cancel job?" (onConfirmed)="cancelJob()">
						Cancel Job
					</button>
					<button mat-button color="primary" rpsharedConfirm="Are you sure you wish to complete the job?"
						(onConfirmed)="completeJob()">
						Complete Job
					</button>
					<button mat-button color="primary" (click)="openPayrollMonthlyReportDialog()">
						Monthly Payroll Report
					</button>
				</mat-card-actions>
				<ng-template #status>
					<small *ngIf="generalInfo.status === JobStatus.Cancelled">Job Cancelled
					</small>
					<small *ngIf="generalInfo.status === JobStatus.Completed">Job Completed On
						<em>{{
							generalInfo.dateCompleted | date: 'longDate':'utc'
							}}</em>
					</small>
				</ng-template>
			</rpshared-mat-loading-card>

			<mat-card fxFlex *ngIf="!(isNonBillableJob$ | async)">
				<mat-progress-bar mode="indeterminate" class="mat-card-loading"
					*ngIf="isLoading$ | async"></mat-progress-bar>
				<rpshared-card-title icon="contact_phone" title="Billing Details">
				</rpshared-card-title>
				<rpshared-billing-details [railroad]="railroad$ | async" [customer]="customer$ | async"
					[editBillingInfo]="editBillingInfo$ | async"
					formControlName="billingDetails"></rpshared-billing-details>
			</mat-card>
		</div>

		<div fxFlex.gt-md="35%" fxLayout="column" fxLayoutGap="8px">
			<rpshared-mat-loading-card icon="history" title="History">
				<mat-tab-group (selectedTabChange)="handleHistorySelectedTabChange($event)">
					<mat-tab [label]="historyTabLabel.job">
						<rpfsa-audit-trail-list [isLoading]="isLoading$ | async"
							[listMessage]="jobLogListMessage$ | async"
							[auditTrails]="jobLogs$ | async"></rpfsa-audit-trail-list>
					</mat-tab>
					<mat-tab [label]="historyTabLabel.quote">
						<rpshared-quote-log-table [isLoading]="isLoading$ | async"
							[listMessage]="quoteLogListMessage$ | async"
							[quoteLogs]="quoteLogs$ | async"></rpshared-quote-log-table>
					</mat-tab>
				</mat-tab-group>
			</rpshared-mat-loading-card>

			<mat-card fxFlex>
				<mat-progress-bar mode="indeterminate" class="mat-card-loading"
					*ngIf="isLoading$ | async"></mat-progress-bar>
				<rpshared-card-title icon="add_location" title="Job Location">
				</rpshared-card-title>
				<rpshared-job-location [subdivisions]="subdivisionChoices$ | async" [showCurrencySelect]="true"
					formControlName="jobLocation"></rpshared-job-location>
			</mat-card>
		</div>
	</div>

	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxLayoutGap="8px" *ngIf="!(isNonBillableJob$ | async)">
		<mat-card fxFlex>
			<mat-progress-bar mode="indeterminate" class="mat-card-loading"
				*ngIf="isLoading$ | async"></mat-progress-bar>
			<rpshared-card-title icon="attach_money" title="Contracted Rates">
				<mat-slide-toggle [formControl]="prevailingWageToggle" (change)="prevailingWageToggled($event.checked)"
					labelPosition="before">Prevailing Wage Applies</mat-slide-toggle>
			</rpshared-card-title>
			<rpshared-contract-rates-list *ngIf="!(hasOnlyOneRate$ | async); else singleRate"
				formControlName="contractedRates" [canMakeChanges]="false"
				[currencyCode]="currencyCode$ | async"></rpshared-contract-rates-list>
			<ng-template #singleRate>
				<rpshared-contract-rates-as-single-item-array formControlName="contractedRates"
					[currencyCode]="currencyCode$ | async">
				</rpshared-contract-rates-as-single-item-array>
			</ng-template>
		</mat-card>

		<div fxFlex.gt-md="35%" fxLayout="column" fxLayoutGap="8px"
			*ngIf="(hasOptionalFields$ | async) || !(isNonBillableJob$ | async)">
			<mat-card *ngIf="hasOptionalFields$ | async">
				<mat-progress-bar mode="indeterminate" class="mat-card-loading"
					*ngIf="isLoading$ | async"></mat-progress-bar>
				<rpshared-card-title icon="list_alt" title="Additional Details"></rpshared-card-title>
				<rpfsa-optional-job-fields [fieldsToShow]="optionalJobFields$ | async"
					[railroadId]="railroadId$ | async" formControlName="optionalJobFields"></rpfsa-optional-job-fields>
			</mat-card>

			<mat-card fxFlex *ngIf="!(isNonBillableJob$ | async)">
				<mat-progress-bar mode="indeterminate" class="mat-card-loading"
					*ngIf="isLoading$ | async"></mat-progress-bar>
				<rpshared-card-title icon="attach_money" title="Purchase Order Details"></rpshared-card-title>
				<rpfsa-purchase-order-details formControlName="purchaseOrderDetails"
					[currencyCode]="currencyCode$ | async"></rpfsa-purchase-order-details>
			</mat-card>
		</div>
	</div>

	<rpshared-mat-loading-card [isLoading]="isLoading$ | async" icon="file_copy" title="Documents">
		<rpshared-document-list [parentId]="id$ | async" target="Job"
			formControlName="documents"></rpshared-document-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card [isLoading]="isLoading$ | async" icon="list" title="Other Charge Items"
		*ngIf="!(isNonBillableJob$ | async)">
		<rpfsa-other-charges [otherCharges]="otherCharges$ | async" [jobId]="id$ | async"
			[currencyCode]="currencyCode$ | async" (refresh)="refreshOtherCharges()"></rpfsa-other-charges>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card [isLoading]="isLoading$ | async" icon="contact_phone" title="Field Contacts">
		<rpshared-contact-list [emailRequired]="false" formControlName="fieldContacts"></rpshared-contact-list>
	</rpshared-mat-loading-card>

	<rpfsa-cost-center-list *ngIf="areCostCentersEnabled$ | async" [jobId]="id$ | async"></rpfsa-cost-center-list>

	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxLayoutGap="8px" *ngIf="prevailingWageToggle.value"
		[@slideInSlideOut]>
		<mat-card fxFlex>
			<mat-progress-bar mode="indeterminate" class="mat-card-loading"
				*ngIf="isLoading$ | async"></mat-progress-bar>
			<rpshared-card-title icon="local_atm" title="Prevailing Wage Info">
				<div *ngIf="
						prevailingWageConfirmation$ | async as confirmation;
						else confirmationDetails
					">
					<small>
						Confirmed By
						<strong>{{ confirmation.confirmedBy }}</strong> on
						<strong>{{
							confirmation.confirmedDate | date: 'shortDate'
							}}</strong>
					</small>
				</div>
				<ng-template #confirmationDetails>
					<button rpsharedConfirm="Confirm Prevailing Wage?" mat-button color="primary"
						(onConfirmed)="confirmPrevailingWage()">
						Confirm Prevailing Wage
					</button>
				</ng-template>
			</rpshared-card-title>
			<rpfsa-prevailing-wage-info formControlName="prevailingWageInfo"></rpfsa-prevailing-wage-info>
		</mat-card>

		<mat-card fxFlex.gt-md="35%" [@slideInSlideOut] *ngIf="prevailingWageToggle.value">
			<mat-progress-bar mode="indeterminate" class="mat-card-loading"
				*ngIf="isLoading$ | async"></mat-progress-bar>
			<rpshared-card-title icon="attach_money" title="Prevailing Wage Rates"></rpshared-card-title>
			<rpfsa-prevailing-wage-rates formControlName="prevailingWageRates"></rpfsa-prevailing-wage-rates>
		</mat-card>
	</div>

	<mat-card>
		<mat-progress-bar mode="indeterminate" class="mat-card-loading" *ngIf="isLoading$ | async"></mat-progress-bar>
		<rpshared-card-title [jobSummary]="job$ | async" icon="assignment" title="Shifts">
		</rpshared-card-title>
		<p class="ml-3">Schedule: {{ descriptionOfSchedule }}</p>
		<rpfsa-shift-list [job]="job$ | async" [showServiceType]="showServiceType$ | async"
			(outRangedShift)="updateJobDateRange($event)">
		</rpfsa-shift-list>
	</mat-card>
</div>